import Account from './Account';
import './Account.scss';

export default Account;
